import Vue from 'vue'
import price from '@/filters/price'
import twoDigits from '@/filters/two-digits'

Vue.filter('price', price)
Vue.filter('twoDigits', twoDigits)
